const regex = (path) => {
  return new RegExp(path);
};
export const transposers = {
  regex,
};
